export default {
  facts: [
    {
      sid: 0,
      facts: [
        { id: 0, item: "Won the Raffle", checked: true },
        { id: 1, item: "Got scolded by Kalyani di", checked: true },
        { id: 2, item: "Got praised by Aunty Mashi", checked: true },
        { id: 3, item: "Snuck to the roof", checked: true },
        {
          id: 4,
          item:
            "Bunked karate/ yoga/ games/ aerobics classes using fake letters",
          checked: true
        },
        {
          id: 5,
          item: "Been a prefect/ monitor/ head boy/ girl",
          checked: false
        },
        { id: 6, item: "Damaged school property", checked: false },
        { id: 7, item: "Was sent home because of dirty shoes", checked: true },
        {
          id: 8,
          item: "Got called down to Madhura Di's office",
          checked: true
        },
        { id: 9, item: "Arrived late to school/assembly", checked: true },
        { id: 10, item: "Led the assembly", checked: true },
        {
          id: 11,
          item: "Performed on Teacher's Day or other programmes",
          checked: true
        },
        { id: 12, item: "Been a fete volunteer/Carol singer", checked: true },
        {
          id: 13,
          item: "Represented school at interschool events",
          checked: true
        },
        { id: 14, item: "Been thrown out of class", checked: true },
        { id: 15, item: "Been a member of Dolna MUN/Quiz club", checked: true },
        { id: 16, item: "Had a BF/GF", checked: false },
        {
          id: 17,
          item: "Was called to the board by Suparna di",
          checked: true
        },
        {
          id: 18,
          item: "Had a crush on a Teacher/Senior/Junior",
          checked: false
        },
        {
          id: 19,
          item: "Article/Essay/Poem published in Reflections",
          checked: true
        },
        { id: 20, item: "Bunked classes", checked: true },
        {
          id: 21,
          item: "Fainted on the terrace during Independence Day celebrations",
          checked: false
        },
        { id: 22, item: "Cheated in the exams", checked: true },
        { id: 23, item: "Did Trinity classes", checked: false },
        {
          id: 24,
          item: "Won medals/ranks during Annual Reports",
          checked: true
        },
        { id: 25, item: "Won Infinity/Cast a Spell finals", checked: false },
        { id: 26, item: "Had coffee from the vending machine", checked: true },
        { id: 27, item: "Had hostel food", checked: false },
        {
          id: 28,
          item: "Went to the library/teachers' room just for the AC",
          checked: true
        },
        {
          id: 29,
          item: "Faked sickness and slept in the sickroom",
          checked: true
        },
        { id: 30, item: "Snacked during classes", checked: true },
        {
          id: 31,
          item: "Carried mobile phone to school secretly",
          checked: true
        }
      ]
    },
    {
      sid: 1,
      facts: [
        { id: 0, item: "Won the Raffle", checked: false },
        { id: 1, item: "Got scolded by Kalyani di", checked: true },
        { id: 2, item: "Got praised by Aunty Mashi", checked: true },
        { id: 3, item: "Snuck to the roof", checked: true },
        {
          id: 4,
          item:
            "Bunked karate/ yoga/ games/ aerobics classes using fake letters",
          checked: true
        },
        {
          id: 5,
          item: "Been a prefect/ monitor/ head boy/ girl",
          checked: false
        },
        { id: 6, item: "Damaged school property", checked: true },
        { id: 7, item: "Was sent home because of dirty shoes", checked: true },
        {
          id: 8,
          item: "Got called down to Madhura Di's office",
          checked: true
        },
        { id: 9, item: "Arrived late to school/assembly", checked: true },
        { id: 10, item: "Led the assembly", checked: false },
        {
          id: 11,
          item: "Performed on Teacher's Day or other programmes",
          checked: true
        },
        { id: 12, item: "Been a fete volunteer/Carol singer", checked: false },
        {
          id: 13,
          item: "Represented school at interschool events",
          checked: false
        },
        { id: 14, item: "Been thrown out of class", checked: true },
        {
          id: 15,
          item: "Been a member of Dolna MUN/Quiz club",
          checked: false
        },
        { id: 16, item: "Had a BF/GF", checked: false },
        {
          id: 17,
          item: "Was called to the board by Suparna di",
          checked: true
        },
        {
          id: 18,
          item: "Had a crush on a Teacher/Senior/Junior",
          checked: true
        },
        {
          id: 19,
          item: "Article/Essay/Poem published in Reflections",
          checked: false
        },
        { id: 20, item: "Bunked classes", checked: true },
        {
          id: 21,
          item: "Fainted on the terrace during Independence Day celebrations",
          checked: false
        },
        { id: 22, item: "Cheated in the exams", checked: true },
        { id: 23, item: "Did Trinity classes", checked: false },
        {
          id: 24,
          item: "Won medals/ranks during Annual Reports",
          checked: true
        },
        { id: 25, item: "Won Infinity/Cast a Spell finals", checked: false },
        { id: 26, item: "Had coffee from the vending machine", checked: true },
        { id: 27, item: "Had hostel food", checked: true },
        {
          id: 28,
          item: "Went to the library/teachers' room just for the AC",
          checked: true
        },
        {
          id: 29,
          item: "Faked sickness and slept in the sickroom",
          checked: true
        },
        { id: 30, item: "Snacked during classes", checked: true },
        {
          id: 31,
          item: "Carried mobile phone to school secretly",
          checked: true
        }
      ]
    },
    {
      sid: 2,
      facts: [
        { id: 0, item: "Won the Raffle", checked: false },
        { id: 1, item: "Got scolded by Kalyani di", checked: true },
        { id: 2, item: "Got praised by Aunty Mashi", checked: true },
        { id: 3, item: "Snuck to the roof", checked: false },
        {
          id: 4,
          item:
            "Bunked karate/ yoga/ games/ aerobics classes using fake letters",
          checked: false
        },
        {
          id: 5,
          item: "Been a prefect/ monitor/ head boy/ girl",
          checked: true
        },
        { id: 6, item: "Damaged school property", checked: false },
        { id: 7, item: "Was sent home because of dirty shoes", checked: false },
        {
          id: 8,
          item: "Got called down to Madhura Di's office",
          checked: true
        },
        { id: 9, item: "Arrived late to school/assembly", checked: true },
        { id: 10, item: "Led the assembly", checked: false },
        {
          id: 11,
          item: "Performed on Teacher's Day or other programmes",
          checked: true
        },
        { id: 12, item: "Been a fete volunteer/Carol singer", checked: true },
        {
          id: 13,
          item: "Represented school at interschool events",
          checked: true
        },
        { id: 14, item: "Been thrown out of class", checked: false },
        {
          id: 15,
          item: "Been a member of Dolna MUN/Quiz club",
          checked: false
        },
        { id: 16, item: "Had a BF/GF", checked: false },
        {
          id: 17,
          item: "Was called to the board by Suparna di",
          checked: false
        },
        {
          id: 18,
          item: "Had a crush on a Teacher/Senior/Junior",
          checked: false
        },
        {
          id: 19,
          item: "Article/Essay/Poem published in Reflections",
          checked: true
        },
        { id: 20, item: "Bunked classes", checked: false },
        {
          id: 21,
          item: "Fainted on the terrace during Independence Day celebrations",
          checked: false
        },
        { id: 22, item: "Cheated in the exams", checked: false },
        { id: 23, item: "Did Trinity classes", checked: true },
        {
          id: 24,
          item: "Won medals/ranks during Annual Reports",
          checked: false
        },
        { id: 25, item: "Won Infinity/Cast a Spell finals", checked: false },
        { id: 26, item: "Had coffee from the vending machine", checked: false },
        { id: 27, item: "Had hostel food", checked: false },
        {
          id: 28,
          item: "Went to the library/teachers' room just for the AC",
          checked: false
        },
        {
          id: 29,
          item: "Faked sickness and slept in the sickroom",
          checked: false
        },
        { id: 30, item: "Snacked during classes", checked: false },
        {
          id: 31,
          item: "Carried mobile phone to school secretly",
          checked: true
        }
      ]
    },
    {
      sid: 3,
      facts: [
        { id: 0, item: "Won the Raffle", checked: true },
        { id: 1, item: "Got scolded by Kalyani di", checked: true },
        { id: 2, item: "Got praised by Aunty Mashi", checked: true },
        { id: 3, item: "Snuck to the roof", checked: false },
        {
          id: 4,
          item:
            "Bunked karate/ yoga/ games/ aerobics classes using fake letters",
          checked: false
        },
        {
          id: 5,
          item: "Been a prefect/ monitor/ head boy/ girl",
          checked: false
        },
        { id: 6, item: "Damaged school property", checked: false },
        { id: 7, item: "Was sent home because of dirty shoes", checked: false },
        {
          id: 8,
          item: "Got called down to Madhura Di's office",
          checked: true
        },
        { id: 9, item: "Arrived late to school/assembly", checked: false },
        { id: 10, item: "Led the assembly", checked: false },
        {
          id: 11,
          item: "Performed on Teacher's Day or other programmes",
          checked: true
        },
        { id: 12, item: "Been a fete volunteer/Carol singer", checked: true },
        {
          id: 13,
          item: "Represented school at interschool events",
          checked: true
        },
        { id: 14, item: "Been thrown out of class", checked: false },
        {
          id: 15,
          item: "Been a member of Dolna MUN/Quiz club",
          checked: false
        },
        { id: 16, item: "Had a BF/GF", checked: true },
        {
          id: 17,
          item: "Was called to the board by Suparna di",
          checked: true
        },
        {
          id: 18,
          item: "Had a crush on a Teacher/Senior/Junior",
          checked: false
        },
        {
          id: 19,
          item: "Article/Essay/Poem published in Reflections",
          checked: true
        },
        { id: 20, item: "Bunked classes", checked: true },
        {
          id: 21,
          item: "Fainted on the terrace during Independence Day celebrations",
          checked: false
        },
        { id: 22, item: "Cheated in the exams", checked: false },
        { id: 23, item: "Did Trinity classes", checked: false },
        {
          id: 24,
          item: "Won medals/ranks during Annual Reports",
          checked: true
        },
        { id: 25, item: "Won Infinity/Cast a Spell finals", checked: false },
        { id: 26, item: "Had coffee from the vending machine", checked: true },
        { id: 27, item: "Had hostel food", checked: false },
        {
          id: 28,
          item: "Went to the library/teachers' room just for the AC",
          checked: true
        },
        {
          id: 29,
          item: "Faked sickness and slept in the sickroom",
          checked: false
        },
        { id: 30, item: "Snacked during classes", checked: true },
        {
          id: 31,
          item: "Carried mobile phone to school secretly",
          checked: false
        }
      ]
    },
    {
      sid: 4,
      facts: [
        { id: 0, item: "Won the Raffle", checked: false },
        { id: 1, item: "Got scolded by Kalyani di", checked: true },
        { id: 2, item: "Got praised by Aunty Mashi", checked: false },
        { id: 3, item: "Snuck to the roof", checked: false },
        {
          id: 4,
          item:
            "Bunked karate/ yoga/ games/ aerobics classes using fake letters",
          checked: false
        },
        {
          id: 5,
          item: "Been a prefect/ monitor/ head boy/ girl",
          checked: true
        },
        { id: 6, item: "Damaged school property", checked: false },
        { id: 7, item: "Was sent home because of dirty shoes", checked: false },
        {
          id: 8,
          item: "Got called down to Madhura Di's office",
          checked: true
        },
        { id: 9, item: "Arrived late to school/assembly", checked: true },
        { id: 10, item: "Led the assembly", checked: false },
        {
          id: 11,
          item: "Performed on Teacher's Day or other programmes",
          checked: true
        },
        { id: 12, item: "Been a fete volunteer/Carol singer", checked: true },
        {
          id: 13,
          item: "Represented school at interschool events",
          checked: true
        },
        { id: 14, item: "Been thrown out of class", checked: true },
        { id: 15, item: "Been a member of Dolna MUN/Quiz club", checked: true },
        { id: 16, item: "Had a BF/GF", checked: false },
        {
          id: 17,
          item: "Was called to the board by Suparna di",
          checked: true
        },
        {
          id: 18,
          item: "Had a crush on a Teacher/Senior/Junior",
          checked: false
        },
        {
          id: 19,
          item: "Article/Essay/Poem published in Reflections",
          checked: true
        },
        { id: 20, item: "Bunked classes", checked: false },
        {
          id: 21,
          item: "Fainted on the terrace during Independence Day celebrations",
          checked: false
        },
        { id: 22, item: "Cheated in the exams", checked: false },
        { id: 23, item: "Did Trinity classes", checked: false },
        {
          id: 24,
          item: "Won medals/ranks during Annual Reports",
          checked: false
        },
        { id: 25, item: "Won Infinity/Cast a Spell finals", checked: false },
        { id: 26, item: "Had coffee from the vending machine", checked: true },
        { id: 27, item: "Had hostel food", checked: false },
        {
          id: 28,
          item: "Went to the library/teachers' room just for the AC",
          checked: false
        },
        {
          id: 29,
          item: "Faked sickness and slept in the sickroom",
          checked: false
        },
        { id: 30, item: "Snacked during classes", checked: false },
        {
          id: 31,
          item: "Carried mobile phone to school secretly",
          checked: false
        }
      ]
    },
    {
      sid: 5,
      facts: [
        { id: 0, item: "Won the Raffle", checked: false },
        { id: 1, item: "Got scolded by Kalyani di", checked: false },
        { id: 2, item: "Got praised by Aunty Mashi", checked: true },
        { id: 3, item: "Snuck to the roof", checked: true },
        {
          id: 4,
          item:
            "Bunked karate/ yoga/ games/ aerobics classes using fake letters",
          checked: true
        },
        {
          id: 5,
          item: "Been a prefect/ monitor/ head boy/ girl",
          checked: false
        },
        { id: 6, item: "Damaged school property", checked: false },
        { id: 7, item: "Was sent home because of dirty shoes", checked: false },
        {
          id: 8,
          item: "Got called down to Madhura Di's office",
          checked: false
        },
        { id: 9, item: "Arrived late to school/assembly", checked: true },
        { id: 10, item: "Led the assembly", checked: false },
        {
          id: 11,
          item: "Performed on Teacher's Day or other programmes",
          checked: true
        },
        { id: 12, item: "Been a fete volunteer/Carol singer", checked: true },
        {
          id: 13,
          item: "Represented school at interschool events",
          checked: true
        },
        { id: 14, item: "Been thrown out of class", checked: true },
        {
          id: 15,
          item: "Been a member of Dolna MUN/Quiz club",
          checked: false
        },
        { id: 16, item: "Had a BF/GF", checked: false },
        {
          id: 17,
          item: "Was called to the board by Suparna di",
          checked: true
        },
        {
          id: 18,
          item: "Had a crush on a Teacher/Senior/Junior",
          checked: true
        },
        {
          id: 19,
          item: "Article/Essay/Poem published in Reflections",
          checked: true
        },
        { id: 20, item: "Bunked classes", checked: false },
        {
          id: 21,
          item: "Fainted on the terrace during Independence Day celebrations",
          checked: false
        },
        { id: 22, item: "Cheated in the exams", checked: false },
        { id: 23, item: "Did Trinity classes", checked: false },
        {
          id: 24,
          item: "Won medals/ranks during Annual Reports",
          checked: true
        },
        { id: 25, item: "Won Infinity/Cast a Spell finals", checked: false },
        { id: 26, item: "Had coffee from the vending machine", checked: true },
        { id: 27, item: "Had hostel food", checked: false },
        {
          id: 28,
          item: "Went to the library/teachers' room just for the AC",
          checked: false
        },
        {
          id: 29,
          item: "Faked sickness and slept in the sickroom",
          checked: false
        },
        { id: 30, item: "Snacked during classes", checked: true },
        {
          id: 31,
          item: "Carried mobile phone to school secretly",
          checked: false
        }
      ]
    },
    {
      sid: 6,
      facts: [
        { id: 0, item: "Won the Raffle", checked: true },
        { id: 1, item: "Got scolded by Kalyani di", checked: true },
        { id: 2, item: "Got praised by Aunty Mashi", checked: true },
        { id: 3, item: "Snuck to the roof", checked: false },
        {
          id: 4,
          item:
            "Bunked karate/ yoga/ games/ aerobics classes using fake letters",
          checked: true
        },
        {
          id: 5,
          item: "Been a prefect/ monitor/ head boy/ girl",
          checked: false
        },
        { id: 6, item: "Damaged school property", checked: false },
        { id: 7, item: "Was sent home because of dirty shoes", checked: false },
        {
          id: 8,
          item: "Got called down to Madhura Di's office",
          checked: true
        },
        { id: 9, item: "Arrived late to school/assembly", checked: true },
        { id: 10, item: "Led the assembly", checked: false },
        {
          id: 11,
          item: "Performed on Teacher's Day or other programmes",
          checked: true
        },
        { id: 12, item: "Been a fete volunteer/Carol singer", checked: true },
        {
          id: 13,
          item: "Represented school at interschool events",
          checked: false
        },
        { id: 14, item: "Been thrown out of class", checked: true },
        { id: 15, item: "Been a member of Dolna MUN/Quiz club", checked: true },
        { id: 16, item: "Had a BF/GF", checked: false },
        {
          id: 17,
          item: "Was called to the board by Suparna di",
          checked: true
        },
        {
          id: 18,
          item: "Had a crush on a Teacher/Senior/Junior",
          checked: false
        },
        {
          id: 19,
          item: "Article/Essay/Poem published in Reflections",
          checked: true
        },
        { id: 20, item: "Bunked classes", checked: true },
        {
          id: 21,
          item: "Fainted on the terrace during Independence Day celebrations",
          checked: false
        },
        { id: 22, item: "Cheated in the exams", checked: false },
        { id: 23, item: "Did Trinity classes", checked: false },
        {
          id: 24,
          item: "Won medals/ranks during Annual Reports",
          checked: false
        },
        { id: 25, item: "Won Infinity/Cast a Spell finals", checked: false },
        { id: 26, item: "Had coffee from the vending machine", checked: true },
        { id: 27, item: "Had hostel food", checked: false },
        {
          id: 28,
          item: "Went to the library/teachers' room just for the AC",
          checked: false
        },
        {
          id: 29,
          item: "Faked sickness and slept in the sickroom",
          checked: false
        },
        { id: 30, item: "Snacked during classes", checked: true },
        {
          id: 31,
          item: "Carried mobile phone to school secretly",
          checked: false
        }
      ]
    },
    {
      sid: 7,
      facts: [
        { id: 0, item: "Won the Raffle", checked: false },
        { id: 1, item: "Got scolded by Kalyani di", checked: true },
        { id: 2, item: "Got praised by Aunty Mashi", checked: true },
        { id: 3, item: "Snuck to the roof", checked: true },
        {
          id: 4,
          item:
            "Bunked karate/ yoga/ games/ aerobics classes using fake letters",
          checked: false
        },
        {
          id: 5,
          item: "Been a prefect/ monitor/ head boy/ girl",
          checked: true
        },
        { id: 6, item: "Damaged school property", checked: false },
        { id: 7, item: "Was sent home because of dirty shoes", checked: true },
        {
          id: 8,
          item: "Got called down to Madhura Di's office",
          checked: true
        },
        { id: 9, item: "Arrived late to school/assembly", checked: true },
        { id: 10, item: "Led the assembly", checked: true },
        {
          id: 11,
          item: "Performed on Teacher's Day or other programmes",
          checked: true
        },
        { id: 12, item: "Been a fete volunteer/Carol singer", checked: true },
        {
          id: 13,
          item: "Represented school at interschool events",
          checked: true
        },
        { id: 14, item: "Been thrown out of class", checked: false },
        {
          id: 15,
          item: "Been a member of Dolna MUN/Quiz club",
          checked: false
        },
        { id: 16, item: "Had a BF/GF", checked: true },
        {
          id: 17,
          item: "Was called to the board by Suparna di",
          checked: true
        },
        {
          id: 18,
          item: "Had a crush on a Teacher/Senior/Junior",
          checked: true
        },
        {
          id: 19,
          item: "Article/Essay/Poem published in Reflections",
          checked: true
        },
        { id: 20, item: "Bunked classes", checked: false },
        {
          id: 21,
          item: "Fainted on the terrace during Independence Day celebrations",
          checked: false
        },
        { id: 22, item: "Cheated in the exams", checked: false },
        { id: 23, item: "Did Trinity classes", checked: true },
        {
          id: 24,
          item: "Won medals/ranks during Annual Reports",
          checked: true
        },
        { id: 25, item: "Won Infinity/Cast a Spell finals", checked: true },
        { id: 26, item: "Had coffee from the vending machine", checked: true },
        { id: 27, item: "Had hostel food", checked: false },
        {
          id: 28,
          item: "Went to the library/teachers' room just for the AC",
          checked: true
        },
        {
          id: 29,
          item: "Faked sickness and slept in the sickroom",
          checked: true
        },
        { id: 30, item: "Snacked during classes", checked: false },
        {
          id: 31,
          item: "Carried mobile phone to school secretly",
          checked: false
        }
      ]
    },
    {
      sid: 8,
      facts: [
        { id: 0, item: "Won the Raffle", checked: false },
        { id: 1, item: "Got scolded by Kalyani di", checked: true },
        { id: 2, item: "Got praised by Aunty Mashi", checked: true },
        { id: 3, item: "Snuck to the roof", checked: true },
        {
          id: 4,
          item:
            "Bunked karate/ yoga/ games/ aerobics classes using fake letters",
          checked: true
        },
        {
          id: 5,
          item: "Been a prefect/ monitor/ head boy/ girl",
          checked: true
        },
        { id: 6, item: "Damaged school property", checked: true },
        { id: 7, item: "Was sent home because of dirty shoes", checked: true },
        {
          id: 8,
          item: "Got called down to Madhura Di's office",
          checked: true
        },
        { id: 9, item: "Arrived late to school/assembly", checked: true },
        { id: 10, item: "Led the assembly", checked: true },
        {
          id: 11,
          item: "Performed on Teacher's Day or other programmes",
          checked: true
        },
        { id: 12, item: "Been a fete volunteer/Carol singer", checked: true },
        {
          id: 13,
          item: "Represented school at interschool events",
          checked: true
        },
        { id: 14, item: "Been thrown out of class", checked: true },
        {
          id: 15,
          item: "Been a member of Dolna MUN/Quiz club",
          checked: false
        },
        { id: 16, item: "Had a BF/GF", checked: true },
        {
          id: 17,
          item: "Was called to the board by Suparna di",
          checked: true
        },
        {
          id: 18,
          item: "Had a crush on a Teacher/Senior/Junior",
          checked: true
        },
        {
          id: 19,
          item: "Article/Essay/Poem published in Reflections",
          checked: true
        },
        { id: 20, item: "Bunked classes", checked: true },
        {
          id: 21,
          item: "Fainted on the terrace during Independence Day celebrations",
          checked: false
        },
        { id: 22, item: "Cheated in the exams", checked: true },
        { id: 23, item: "Did Trinity classes", checked: false },
        {
          id: 24,
          item: "Won medals/ranks during Annual Reports",
          checked: false
        },
        { id: 25, item: "Won Infinity/Cast a Spell finals", checked: false },
        { id: 26, item: "Had coffee from the vending machine", checked: true },
        { id: 27, item: "Had hostel food", checked: false },
        {
          id: 28,
          item: "Went to the library/teachers' room just for the AC",
          checked: true
        },
        {
          id: 29,
          item: "Faked sickness and slept in the sickroom",
          checked: false
        },
        { id: 30, item: "Snacked during classes", checked: true },
        {
          id: 31,
          item: "Carried mobile phone to school secretly",
          checked: true
        }
      ]
    },
    {
      sid: 9,
      facts: [
        { id: 0, item: "Won the Raffle", checked: false },
        { id: 1, item: "Got scolded by Kalyani di", checked: true },
        { id: 2, item: "Got praised by Aunty Mashi", checked: true },
        { id: 3, item: "Snuck to the roof", checked: true },
        {
          id: 4,
          item:
            "Bunked karate/ yoga/ games/ aerobics classes using fake letters",
          checked: false
        },
        {
          id: 5,
          item: "Been a prefect/ monitor/ head boy/ girl",
          checked: false
        },
        { id: 6, item: "Damaged school property", checked: false },
        { id: 7, item: "Was sent home because of dirty shoes", checked: false },
        {
          id: 8,
          item: "Got called down to Madhura Di's office",
          checked: true
        },
        { id: 9, item: "Arrived late to school/assembly", checked: true },
        { id: 10, item: "Led the assembly", checked: false },
        {
          id: 11,
          item: "Performed on Teacher's Day or other programmes",
          checked: true
        },
        { id: 12, item: "Been a fete volunteer/Carol singer", checked: true },
        {
          id: 13,
          item: "Represented school at interschool events",
          checked: true
        },
        { id: 14, item: "Been thrown out of class", checked: true },
        {
          id: 15,
          item: "Been a member of Dolna MUN/Quiz club",
          checked: false
        },
        { id: 16, item: "Had a BF/GF", checked: true },
        {
          id: 17,
          item: "Was called to the board by Suparna di",
          checked: true
        },
        {
          id: 18,
          item: "Had a crush on a Teacher/Senior/Junior",
          checked: true
        },
        {
          id: 19,
          item: "Article/Essay/Poem published in Reflections",
          checked: true
        },
        { id: 20, item: "Bunked classes", checked: false },
        {
          id: 21,
          item: "Fainted on the terrace during Independence Day celebrations",
          checked: false
        },
        { id: 22, item: "Cheated in the exams", checked: false },
        { id: 23, item: "Did Trinity classes", checked: false },
        {
          id: 24,
          item: "Won medals/ranks during Annual Reports",
          checked: false
        },
        { id: 25, item: "Won Infinity/Cast a Spell finals", checked: false },
        { id: 26, item: "Had coffee from the vending machine", checked: true },
        { id: 27, item: "Had hostel food", checked: false },
        {
          id: 28,
          item: "Went to the library/teachers' room just for the AC",
          checked: true
        },
        {
          id: 29,
          item: "Faked sickness and slept in the sickroom",
          checked: false
        },
        { id: 30, item: "Snacked during classes", checked: true },
        {
          id: 31,
          item: "Carried mobile phone to school secretly",
          checked: true
        }
      ]
    },
    {
      sid: 11,
      facts: [
        { id: 0, item: "Won the Raffle", checked: false },
        { id: 1, item: "Got scolded by Kalyani di", checked: true },
        { id: 2, item: "Got praised by Aunty Mashi", checked: true },
        { id: 3, item: "Snuck to the roof", checked: false },
        {
          id: 4,
          item:
            "Bunked karate/ yoga/ games/ aerobics classes using fake letters",
          checked: true
        },
        {
          id: 5,
          item: "Been a prefect/ monitor/ head boy/ girl",
          checked: true
        },
        { id: 6, item: "Damaged school property", checked: true },
        { id: 7, item: "Was sent home because of dirty shoes", checked: false },
        {
          id: 8,
          item: "Got called down to Madhura Di's office",
          checked: true
        },
        { id: 9, item: "Arrived late to school/assembly", checked: true },
        { id: 10, item: "Led the assembly", checked: false },
        {
          id: 11,
          item: "Performed on Teacher's Day or other programmes",
          checked: true
        },
        { id: 12, item: "Been a fete volunteer/Carol singer", checked: true },
        {
          id: 13,
          item: "Represented school at interschool events",
          checked: false
        },
        { id: 14, item: "Been thrown out of class", checked: true },
        {
          id: 15,
          item: "Been a member of Dolna MUN/Quiz club",
          checked: false
        },
        { id: 16, item: "Had a BF/GF", checked: false },
        {
          id: 17,
          item: "Was called to the board by Suparna di",
          checked: true
        },
        {
          id: 18,
          item: "Had a crush on a Teacher/Senior/Junior",
          checked: true
        },
        {
          id: 19,
          item: "Article/Essay/Poem published in Reflections",
          checked: true
        },
        { id: 20, item: "Bunked classes", checked: false },
        {
          id: 21,
          item: "Fainted on the terrace during Independence Day celebrations",
          checked: true
        },
        { id: 22, item: "Cheated in the exams", checked: true },
        { id: 23, item: "Did Trinity classes", checked: true },
        {
          id: 24,
          item: "Won medals/ranks during Annual Reports",
          checked: true
        },
        { id: 25, item: "Won Infinity/Cast a Spell finals", checked: false },
        { id: 26, item: "Had coffee from the vending machine", checked: true },
        { id: 27, item: "Had hostel food", checked: false },
        {
          id: 28,
          item: "Went to the library/teachers' room just for the AC",
          checked: true
        },
        {
          id: 29,
          item: "Faked sickness and slept in the sickroom",
          checked: false
        },
        { id: 30, item: "Snacked during classes", checked: true },
        {
          id: 31,
          item: "Carried mobile phone to school secretly",
          checked: false
        }
      ]
    },
    {
      sid: 12,
      facts: [
        { id: 0, item: "Won the Raffle", checked: false },
        { id: 1, item: "Got scolded by Kalyani di", checked: true },
        { id: 2, item: "Got praised by Aunty Mashi", checked: true },
        { id: 3, item: "Snuck to the roof", checked: true },
        {
          id: 4,
          item:
            "Bunked karate/ yoga/ games/ aerobics classes using fake letters",
          checked: true
        },
        {
          id: 5,
          item: "Been a prefect/ monitor/ head boy/ girl",
          checked: false
        },
        { id: 6, item: "Damaged school property", checked: true },
        { id: 7, item: "Was sent home because of dirty shoes", checked: true },
        {
          id: 8,
          item: "Got called down to Madhura Di's office",
          checked: true
        },
        { id: 9, item: "Arrived late to school/assembly", checked: true },
        { id: 10, item: "Led the assembly", checked: true },
        {
          id: 11,
          item: "Performed on Teacher's Day or other programmes",
          checked: true
        },
        { id: 12, item: "Been a fete volunteer/Carol singer", checked: true },
        {
          id: 13,
          item: "Represented school at interschool events",
          checked: true
        },
        { id: 14, item: "Been thrown out of class", checked: true },
        { id: 15, item: "Been a member of Dolna MUN/Quiz club", checked: true },
        { id: 16, item: "Had a BF/GF", checked: false },
        {
          id: 17,
          item: "Was called to the board by Suparna di",
          checked: true
        },
        {
          id: 18,
          item: "Had a crush on a Teacher/Senior/Junior",
          checked: false
        },
        {
          id: 19,
          item: "Article/Essay/Poem published in Reflections",
          checked: true
        },
        { id: 20, item: "Bunked classes", checked: true },
        {
          id: 21,
          item: "Fainted on the terrace during Independence Day celebrations",
          checked: false
        },
        { id: 22, item: "Cheated in the exams", checked: true },
        { id: 23, item: "Did Trinity classes", checked: true },
        {
          id: 24,
          item: "Won medals/ranks during Annual Reports",
          checked: true
        },
        { id: 25, item: "Won Infinity/Cast a Spell finals", checked: false },
        { id: 26, item: "Had coffee from the vending machine", checked: true },
        { id: 27, item: "Had hostel food", checked: true },
        {
          id: 28,
          item: "Went to the library/teachers' room just for the AC",
          checked: true
        },
        {
          id: 29,
          item: "Faked sickness and slept in the sickroom",
          checked: false
        },
        { id: 30, item: "Snacked during classes", checked: true },
        {
          id: 31,
          item: "Carried mobile phone to school secretly",
          checked: false
        }
      ]
    },
    {
      sid: 13,
      facts: [
        { id: 0, item: "Won the Raffle", checked: false },
        { id: 1, item: "Got scolded by Kalyani di", checked: true },
        { id: 2, item: "Got praised by Aunty Mashi", checked: true },
        { id: 3, item: "Snuck to the roof", checked: false },
        {
          id: 4,
          item:
            "Bunked karate/ yoga/ games/ aerobics classes using fake letters",
          checked: true
        },
        {
          id: 5,
          item: "Been a prefect/ monitor/ head boy/ girl",
          checked: true
        },
        { id: 6, item: "Damaged school property", checked: false },
        { id: 7, item: "Was sent home because of dirty shoes", checked: false },
        {
          id: 8,
          item: "Got called down to Madhura Di's office",
          checked: true
        },
        { id: 9, item: "Arrived late to school/assembly", checked: true },
        { id: 10, item: "Led the assembly", checked: false },
        {
          id: 11,
          item: "Performed on Teacher's Day or other programmes",
          checked: true
        },
        { id: 12, item: "Been a fete volunteer/Carol singer", checked: true },
        {
          id: 13,
          item: "Represented school at interschool events",
          checked: true
        },
        { id: 14, item: "Been thrown out of class", checked: true },
        { id: 15, item: "Been a member of Dolna MUN/Quiz club", checked: true },
        { id: 16, item: "Had a BF/GF", checked: true },
        {
          id: 17,
          item: "Was called to the board by Suparna di",
          checked: true
        },
        {
          id: 18,
          item: "Had a crush on a Teacher/Senior/Junior",
          checked: false
        },
        {
          id: 19,
          item: "Article/Essay/Poem published in Reflections",
          checked: true
        },
        { id: 20, item: "Bunked classes", checked: true },
        {
          id: 21,
          item: "Fainted on the terrace during Independence Day celebrations",
          checked: false
        },
        { id: 22, item: "Cheated in the exams", checked: true },
        { id: 23, item: "Did Trinity classes", checked: true },
        {
          id: 24,
          item: "Won medals/ranks during Annual Reports",
          checked: true
        },
        { id: 25, item: "Won Infinity/Cast a Spell finals", checked: false },
        { id: 26, item: "Had coffee from the vending machine", checked: true },
        { id: 27, item: "Had hostel food", checked: false },
        {
          id: 28,
          item: "Went to the library/teachers' room just for the AC",
          checked: false
        },
        {
          id: 29,
          item: "Faked sickness and slept in the sickroom",
          checked: false
        },
        { id: 30, item: "Snacked during classes", checked: true },
        {
          id: 31,
          item: "Carried mobile phone to school secretly",
          checked: false
        }
      ]
    },
    {
      sid: 17,
      facts: [
        { id: 0, item: "Won the Raffle", checked: false },
        { id: 1, item: "Got scolded by Kalyani di", checked: true },
        { id: 2, item: "Got praised by Aunty Mashi", checked: true },
        { id: 3, item: "Snuck to the roof", checked: true },
        {
          id: 4,
          item:
            "Bunked karate/ yoga/ games/ aerobics classes using fake letters",
          checked: true
        },
        {
          id: 5,
          item: "Been a prefect/ monitor/ head boy/ girl",
          checked: true
        },
        { id: 6, item: "Damaged school property", checked: false },
        { id: 7, item: "Was sent home because of dirty shoes", checked: false },
        {
          id: 8,
          item: "Got called down to Madhura Di's office",
          checked: true
        },
        { id: 9, item: "Arrived late to school/assembly", checked: true },
        { id: 10, item: "Led the assembly", checked: false },
        {
          id: 11,
          item: "Performed on Teacher's Day or other programmes",
          checked: true
        },
        { id: 12, item: "Been a fete volunteer/Carol singer", checked: true },
        {
          id: 13,
          item: "Represented school at interschool events",
          checked: false
        },
        { id: 14, item: "Been thrown out of class", checked: true },
        {
          id: 15,
          item: "Been a member of Dolna MUN/Quiz club",
          checked: false
        },
        { id: 16, item: "Had a BF/GF", checked: true },
        {
          id: 17,
          item: "Was called to the board by Suparna di",
          checked: true
        },
        {
          id: 18,
          item: "Had a crush on a Teacher/Senior/Junior",
          checked: true
        },
        {
          id: 19,
          item: "Article/Essay/Poem published in Reflections",
          checked: true
        },
        { id: 20, item: "Bunked classes", checked: false },
        {
          id: 21,
          item: "Fainted on the terrace during Independence Day celebrations",
          checked: false
        },
        { id: 22, item: "Cheated in the exams", checked: false },
        { id: 23, item: "Did Trinity classes", checked: false },
        {
          id: 24,
          item: "Won medals/ranks during Annual Reports",
          checked: false
        },
        { id: 25, item: "Won Infinity/Cast a Spell finals", checked: false },
        { id: 26, item: "Had coffee from the vending machine", checked: true },
        { id: 27, item: "Had hostel food", checked: false },
        {
          id: 28,
          item: "Went to the library/teachers' room just for the AC",
          checked: true
        },
        {
          id: 29,
          item: "Faked sickness and slept in the sickroom",
          checked: true
        },
        { id: 30, item: "Snacked during classes", checked: true },
        {
          id: 31,
          item: "Carried mobile phone to school secretly",
          checked: true
        }
      ]
    },
    {
      sid: 21,
      facts: [
        { id: 0, item: "Won the Raffle", checked: false },
        { id: 1, item: "Got scolded by Kalyani di", checked: true },
        { id: 2, item: "Got praised by Aunty Mashi", checked: true },
        { id: 3, item: "Snuck to the roof", checked: true },
        {
          id: 4,
          item:
            "Bunked karate/ yoga/ games/ aerobics classes using fake letters",
          checked: true
        },
        {
          id: 5,
          item: "Been a prefect/ monitor/ head boy/ girl",
          checked: true
        },
        { id: 6, item: "Damaged school property", checked: false },
        { id: 7, item: "Was sent home because of dirty shoes", checked: false },
        {
          id: 8,
          item: "Got called down to Madhura Di's office",
          checked: true
        },
        { id: 9, item: "Arrived late to school/assembly", checked: true },
        { id: 10, item: "Led the assembly", checked: false },
        {
          id: 11,
          item: "Performed on Teacher's Day or other programmes",
          checked: true
        },
        { id: 12, item: "Been a fete volunteer/Carol singer", checked: true },
        {
          id: 13,
          item: "Represented school at interschool events",
          checked: true
        },
        { id: 14, item: "Been thrown out of class", checked: true },
        {
          id: 15,
          item: "Been a member of Dolna MUN/Quiz club",
          checked: false
        },
        { id: 16, item: "Had a BF/GF", checked: true },
        {
          id: 17,
          item: "Was called to the board by Suparna di",
          checked: true
        },
        {
          id: 18,
          item: "Had a crush on a Teacher/Senior/Junior",
          checked: true
        },
        {
          id: 19,
          item: "Article/Essay/Poem published in Reflections",
          checked: false
        },
        { id: 20, item: "Bunked classes", checked: true },
        {
          id: 21,
          item: "Fainted on the terrace during Independence Day celebrations",
          checked: false
        },
        { id: 22, item: "Cheated in the exams", checked: true },
        { id: 23, item: "Did Trinity classes", checked: false },
        {
          id: 24,
          item: "Won medals/ranks during Annual Reports",
          checked: false
        },
        { id: 25, item: "Won Infinity/Cast a Spell finals", checked: false },
        { id: 26, item: "Had coffee from the vending machine", checked: true },
        { id: 27, item: "Had hostel food", checked: false },
        {
          id: 28,
          item: "Went to the library/teachers' room just for the AC",
          checked: true
        },
        {
          id: 29,
          item: "Faked sickness and slept in the sickroom",
          checked: false
        },
        { id: 30, item: "Snacked during classes", checked: true },
        {
          id: 31,
          item: "Carried mobile phone to school secretly",
          checked: true
        }
      ]
    },
    {
      sid: 22,
      facts: [
        { id: 0, item: "Won the Raffle", checked: false },
        { id: 1, item: "Got scolded by Kalyani di", checked: true },
        { id: 2, item: "Got praised by Aunty Mashi", checked: true },
        { id: 3, item: "Snuck to the roof", checked: false },
        {
          id: 4,
          item:
            "Bunked karate/ yoga/ games/ aerobics classes using fake letters",
          checked: true
        },
        {
          id: 5,
          item: "Been a prefect/ monitor/ head boy/ girl",
          checked: false
        },
        { id: 6, item: "Damaged school property", checked: true },
        { id: 7, item: "Was sent home because of dirty shoes", checked: true },
        {
          id: 8,
          item: "Got called down to Madhura Di's office",
          checked: true
        },
        { id: 9, item: "Arrived late to school/assembly", checked: true },
        { id: 10, item: "Led the assembly", checked: true },
        {
          id: 11,
          item: "Performed on Teacher's Day or other programmes",
          checked: false
        },
        { id: 12, item: "Been a fete volunteer/Carol singer", checked: true },
        {
          id: 13,
          item: "Represented school at interschool events",
          checked: true
        },
        { id: 14, item: "Been thrown out of class", checked: true },
        {
          id: 15,
          item: "Been a member of Dolna MUN/Quiz club",
          checked: false
        },
        { id: 16, item: "Had a BF/GF", checked: false },
        {
          id: 17,
          item: "Was called to the board by Suparna di",
          checked: true
        },
        {
          id: 18,
          item: "Had a crush on a Teacher/Senior/Junior",
          checked: true
        },
        {
          id: 19,
          item: "Article/Essay/Poem published in Reflections",
          checked: true
        },
        { id: 20, item: "Bunked classes", checked: true },
        {
          id: 21,
          item: "Fainted on the terrace during Independence Day celebrations",
          checked: false
        },
        { id: 22, item: "Cheated in the exams", checked: false },
        { id: 23, item: "Did Trinity classes", checked: false },
        {
          id: 24,
          item: "Won medals/ranks during Annual Reports",
          checked: true
        },
        { id: 25, item: "Won Infinity/Cast a Spell finals", checked: true },
        { id: 26, item: "Had coffee from the vending machine", checked: true },
        { id: 27, item: "Had hostel food", checked: true },
        {
          id: 28,
          item: "Went to the library/teachers' room just for the AC",
          checked: true
        },
        {
          id: 29,
          item: "Faked sickness and slept in the sickroom",
          checked: true
        },
        { id: 30, item: "Snacked during classes", checked: true },
        {
          id: 31,
          item: "Carried mobile phone to school secretly",
          checked: false
        }
      ]
    },
    {
      sid: 29,
      facts: [
        { id: 0, item: "Won the Raffle", checked: false },
        { id: 1, item: "Got scolded by Kalyani di", checked: true },
        { id: 2, item: "Got praised by Aunty Mashi", checked: true },
        { id: 3, item: "Snuck to the roof", checked: true },
        {
          id: 4,
          item:
            "Bunked karate/ yoga/ games/ aerobics classes using fake letters",
          checked: true
        },
        {
          id: 5,
          item: "Been a prefect/ monitor/ head boy/ girl",
          checked: true
        },
        { id: 6, item: "Damaged school property", checked: true },
        { id: 7, item: "Was sent home because of dirty shoes", checked: true },
        {
          id: 8,
          item: "Got called down to Madhura Di's office",
          checked: true
        },
        { id: 9, item: "Arrived late to school/assembly", checked: true },
        { id: 10, item: "Led the assembly", checked: false },
        {
          id: 11,
          item: "Performed on Teacher's Day or other programmes",
          checked: true
        },
        { id: 12, item: "Been a fete volunteer/Carol singer", checked: true },
        {
          id: 13,
          item: "Represented school at interschool events",
          checked: false
        },
        { id: 14, item: "Been thrown out of class", checked: true },
        { id: 15, item: "Been a member of Dolna MUN/Quiz club", checked: true },
        { id: 16, item: "Had a BF/GF", checked: false },
        {
          id: 17,
          item: "Was called to the board by Suparna di",
          checked: true
        },
        {
          id: 18,
          item: "Had a crush on a Teacher/Senior/Junior",
          checked: false
        },
        {
          id: 19,
          item: "Article/Essay/Poem published in Reflections",
          checked: false
        },
        { id: 20, item: "Bunked classes", checked: true },
        {
          id: 21,
          item: "Fainted on the terrace during Independence Day celebrations",
          checked: false
        },
        { id: 22, item: "Cheated in the exams", checked: true },
        { id: 23, item: "Did Trinity classes", checked: false },
        {
          id: 24,
          item: "Won medals/ranks during Annual Reports",
          checked: false
        },
        { id: 25, item: "Won Infinity/Cast a Spell finals", checked: false },
        { id: 26, item: "Had coffee from the vending machine", checked: true },
        { id: 27, item: "Had hostel food", checked: true },
        {
          id: 28,
          item: "Went to the library/teachers' room just for the AC",
          checked: true
        },
        {
          id: 29,
          item: "Faked sickness and slept in the sickroom",
          checked: true
        },
        { id: 30, item: "Snacked during classes", checked: true },
        {
          id: 31,
          item: "Carried mobile phone to school secretly",
          checked: false
        }
      ]
    },
    {
      sid: 33,
      facts: [
        { id: 0, item: "Won the Raffle", checked: false },
        { id: 1, item: "Got scolded by Kalyani di", checked: true },
        { id: 2, item: "Got praised by Aunty Mashi", checked: true },
        { id: 3, item: "Snuck to the roof", checked: false },
        {
          id: 4,
          item:
            "Bunked karate/ yoga/ games/ aerobics classes using fake letters",
          checked: false
        },
        {
          id: 5,
          item: "Been a prefect/ monitor/ head boy/ girl",
          checked: true
        },
        { id: 6, item: "Damaged school property", checked: true },
        { id: 7, item: "Was sent home because of dirty shoes", checked: false },
        {
          id: 8,
          item: "Got called down to Madhura Di's office",
          checked: true
        },
        { id: 9, item: "Arrived late to school/assembly", checked: true },
        { id: 10, item: "Led the assembly", checked: true },
        {
          id: 11,
          item: "Performed on Teacher's Day or other programmes",
          checked: true
        },
        { id: 12, item: "Been a fete volunteer/Carol singer", checked: true },
        {
          id: 13,
          item: "Represented school at interschool events",
          checked: true
        },
        { id: 14, item: "Been thrown out of class", checked: true },
        { id: 15, item: "Been a member of Dolna MUN/Quiz club", checked: true },
        { id: 16, item: "Had a BF/GF", checked: true },
        {
          id: 17,
          item: "Was called to the board by Suparna di",
          checked: true
        },
        {
          id: 18,
          item: "Had a crush on a Teacher/Senior/Junior",
          checked: false
        },
        {
          id: 19,
          item: "Article/Essay/Poem published in Reflections",
          checked: true
        },
        { id: 20, item: "Bunked classes", checked: false },
        {
          id: 21,
          item: "Fainted on the terrace during Independence Day celebrations",
          checked: false
        },
        { id: 22, item: "Cheated in the exams", checked: false },
        { id: 23, item: "Did Trinity classes", checked: false },
        {
          id: 24,
          item: "Won medals/ranks during Annual Reports",
          checked: true
        },
        { id: 25, item: "Won Infinity/Cast a Spell finals", checked: true },
        { id: 26, item: "Had coffee from the vending machine", checked: false },
        { id: 27, item: "Had hostel food", checked: true },
        {
          id: 28,
          item: "Went to the library/teachers' room just for the AC",
          checked: true
        },
        {
          id: 29,
          item: "Faked sickness and slept in the sickroom",
          checked: false
        },
        { id: 30, item: "Snacked during classes", checked: false },
        {
          id: 31,
          item: "Carried mobile phone to school secretly",
          checked: false
        }
      ]
    },
    {
      sid: 34,
      facts: [
        { id: 0, item: "Won the Raffle", checked: false },
        { id: 1, item: "Got scolded by Kalyani di", checked: false },
        { id: 2, item: "Got praised by Aunty Mashi", checked: true },
        { id: 3, item: "Snuck to the roof", checked: false },
        {
          id: 4,
          item:
            "Bunked karate/ yoga/ games/ aerobics classes using fake letters",
          checked: false
        },
        {
          id: 5,
          item: "Been a prefect/ monitor/ head boy/ girl",
          checked: false
        },
        { id: 6, item: "Damaged school property", checked: false },
        { id: 7, item: "Was sent home because of dirty shoes", checked: false },
        {
          id: 8,
          item: "Got called down to Madhura Di's office",
          checked: false
        },
        { id: 9, item: "Arrived late to school/assembly", checked: true },
        { id: 10, item: "Led the assembly", checked: true },
        {
          id: 11,
          item: "Performed on Teacher's Day or other programmes",
          checked: false
        },
        { id: 12, item: "Been a fete volunteer/Carol singer", checked: true },
        {
          id: 13,
          item: "Represented school at interschool events",
          checked: false
        },
        { id: 14, item: "Been thrown out of class", checked: false },
        {
          id: 15,
          item: "Been a member of Dolna MUN/Quiz club",
          checked: false
        },
        { id: 16, item: "Had a BF/GF", checked: false },
        {
          id: 17,
          item: "Was called to the board by Suparna di",
          checked: true
        },
        {
          id: 18,
          item: "Had a crush on a Teacher/Senior/Junior",
          checked: false
        },
        {
          id: 19,
          item: "Article/Essay/Poem published in Reflections",
          checked: true
        },
        { id: 20, item: "Bunked classes", checked: false },
        {
          id: 21,
          item: "Fainted on the terrace during Independence Day celebrations",
          checked: false
        },
        { id: 22, item: "Cheated in the exams", checked: false },
        { id: 23, item: "Did Trinity classes", checked: true },
        {
          id: 24,
          item: "Won medals/ranks during Annual Reports",
          checked: false
        },
        { id: 25, item: "Won Infinity/Cast a Spell finals", checked: false },
        { id: 26, item: "Had coffee from the vending machine", checked: true },
        { id: 27, item: "Had hostel food", checked: false },
        {
          id: 28,
          item: "Went to the library/teachers' room just for the AC",
          checked: false
        },
        {
          id: 29,
          item: "Faked sickness and slept in the sickroom",
          checked: false
        },
        { id: 30, item: "Snacked during classes", checked: false },
        {
          id: 31,
          item: "Carried mobile phone to school secretly",
          checked: false
        }
      ]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/data/facts.js